var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSouthKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_kr_flag_simple"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 24,
    rx: 3,
    ry: 3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "disc"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12.5,
    r: 4.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_kr_flag_simple)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 24,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#disc)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.4,
    y: 7.9,
    width: 9.2,
    height: 4.6,
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4,
    y: 12.5,
    width: 9.2,
    height: 4.6,
    fill: "#0047A0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6,6) rotate(-30)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: -3.9,
    width: 9.4,
    height: 1.8,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: -1,
    width: 9.4,
    height: 1.8,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: 1.9,
    width: 9.4,
    height: 1.8,
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.3,18.6) rotate(30)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: -3.9,
    width: 9.4,
    height: 1.8,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: -1,
    width: 3.9,
    height: 1.8,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: -1,
    width: 3.9,
    height: 1.8,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: 1.9,
    width: 9.4,
    height: 1.8,
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,6.3) rotate(30)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: -3.9,
    width: 3.9,
    height: 1.8,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: -3.9,
    width: 3.9,
    height: 1.8,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: -1,
    width: 9.4,
    height: 1.8,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: 1.9,
    width: 3.9,
    height: 1.8,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 1.9,
    width: 3.9,
    height: 1.8,
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.8,18.4) rotate(-30)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: -3.9,
    width: 9.4,
    height: 1.8,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: -1,
    width: 9.4,
    height: 1.8,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: 1.9,
    width: 9.4,
    height: 1.8,
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthKorea);
export default __webpack_public_path__ + "static/media/southKorea.36e8919c6cd84749cb6e61a3c15fee62.svg";
export { ForwardRef as ReactComponent };